import type { LoanFeatures } from '../types/LoanFeatures';

export const gatekeeperFlags: LoanFeatures = {
    loans: {
        enabled: true,
        _description: 'Enables the whole loan product including loading, main display',
    },
    moneyOnClick: {
        enabled: false,
        _description: 'Enables money on click display, drawdown and payback feature',
    },
    loanRepayment: {
        enabled: false,
        _description: 'Enables the whole early loan repayment (often referred as ELR) feature',
    },
    loanInsurance: {
        enabled: false,
        _description: 'Enables the payment protection insurance feature',
    },
    loanTicketingServices: {
        enabled: true,
        _description: 'Enables the loan ticketing',
    },
};
